<template>
  <div class="fixed bottom-0 left-0 z-30 w-screen">
    <aside>
      <UMarketingBanner />
    </aside>
    <UMobileNavigation />
  </div>
</template>
